import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { UrlTree } from '@angular/router';
import { Observable, forkJoin, from, map, of, take } from 'rxjs';
import { GuestAuthService } from '../../services/guest-auth.service';
import { GuestService } from '../../services/guest.service';
import { UserService } from '../../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryIdentificationGuard {
  private userService = inject(UserService);
  private guestService = inject(GuestService);
  private guestAuthService = inject(GuestAuthService);
  private platformId = inject<string>(PLATFORM_ID);

  canActivate(): Observable<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return of(true);
    return forkJoin([
      from(this.guestService.getGuest()).pipe(
        take(1),
        map(guest => !!guest)
      ),
      this.userService.getUser().pipe(
        take(1),
        map(user => !!user)
      ),
    ]).pipe(
      map(([guestLoggedIn, userLoggedIn]) => {
        if (userLoggedIn || guestLoggedIn) return true;
        this.guestAuthService.prepAnonymousGuest();
        return true;
      })
    );
  }
}
